import PropTypes from "prop-types";
import { Button } from "@mui/material";

import { useSupportSlider } from "./TopBarSupportIcon";

// Opens the in-app support ticket form instead of linking out to the
// retired Atlassian help portal (SUPPORT_WEBSITE), which now shows
// "Page unavailable".
const ContactSupportButton = ({
  email,
  userName,
  companyName,
  subject,
  message,
  label = "Contact Support",
  ...buttonProps
}) => {
  const { openSupport, supportSliderJsx } = useSupportSlider({
    email,
    userName,
    companyName,
    subject,
    message,
    showHelpCenter: false,
  });

  return (
    <>
      {supportSliderJsx}
      <Button
        variant="contained"
        color="primary"
        onClick={openSupport}
        {...buttonProps}
      >
        {label}
      </Button>
    </>
  );
};

ContactSupportButton.propTypes = {
  email: PropTypes.string,
  userName: PropTypes.string,
  companyName: PropTypes.string,
  subject: PropTypes.string,
  message: PropTypes.string,
  label: PropTypes.node,
};

export default ContactSupportButton;
